import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import AccountUserDetailPageUI from './AccountUserDetailPageUI.js'

class AccountUserDetailPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      accountUser: null
    }
  }

  render() {
    return (
      <AccountUserDetailPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        accountUser={this.state.accountUser}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccountUsers(context)
    this.getMessages(context)
  }

  getAccountUsers(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/users`,
      cacheKey: CacheKeys.AccountUsers(context.session.accountId),
      callback: this.getAccountUsersCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountUsersCallback = (response) => {
    let accountUser = response.accountUserList.find(au => au.userId === this.props.match.params.userId)
    this.setState({ accountUser: accountUser})
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.AccountUsers(context.session.accountId))
    this.setState({errorList: null, accountUserList: null})
    this.getAccountUsers(context)
  }

  getMessages(context) {
    let arr = [
      'c_user',
      'c_email',
      'c_update'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_acc_user', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default withRouter(AccountUserDetailPageSF)
